import React from 'react';
import { Label } from 'rbx';
import { isNaN } from 'lodash';
import moment from 'moment-timezone';
import styled from 'styled-components';

import RefundStats from '../RefundBooking/RefundStats';

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 75vw;
  align-items: start;
`;

const BookingDetailsItem = styled.div`
  display: grid;
  grid-template-columns: 0.75fr 1.25fr;
  width: 100%;
  gap: 2rem 0;
  padding: 2rem;
`;

const PaymentsTab = ({
  tableBookingDataProps,
  tableSettingProps,
  refundSummary,
}) => (
  <GridContainer className="m-4">
    <div>
      <Label>Payment Details</Label>
      <BookingDetailsItem>
        {tableBookingDataProps?.billing?.sub_total && (
          <>
            <div>
              Deposit{' '}
              {tableBookingDataProps?.guest_count &&
              tableSettingProps?.booking_fee?.booking_fee_info
                ?.booking_deposit &&
              tableSettingProps?.booking_fee?.booking_fee_info?.booking_type ===
                'FEE_PER_GUEST'
                ? ` ($${parseFloat(
                    tableSettingProps?.booking_fee?.booking_fee_info
                      ?.booking_deposit,
                  )} x ${tableBookingDataProps?.guest_count})`
                : ''}
            </div>
            <div>
              $
              {parseFloat(tableBookingDataProps?.billing?.sub_total).toFixed(2)}
            </div>
          </>
        )}
        {tableBookingDataProps?.billing?.sub_total && (
          <>
            <p>Subtotal</p>
            <p>
              $
              {parseFloat(tableBookingDataProps?.billing?.sub_total).toFixed(2)}
            </p>
          </>
        )}
        {Array.isArray(tableBookingDataProps?.billing?.charges_list) &&
          tableBookingDataProps?.billing?.charges_list
            .filter(
              chg =>
                !chg.is_payment_gateway_fee &&
                chg.is_payment_gateway_fee !== null,
            )
            .filter(chg => {
              const tempValue = parseFloat(chg.value);
              return tempValue !== 0 && !isNaN(tempValue);
            })
            .map(chg => (
              <React.Fragment key={chg.name}>
                <p>{chg.name}</p>
                <p>${parseFloat(chg.value).toFixed(2)}</p>
              </React.Fragment>
            ))}
        {!!tableBookingDataProps?.billing?.payment_gateway_fee && (
          <>
            <p>Card Processing Fee</p>
            <p>
              $
              {parseFloat(
                tableBookingDataProps?.billing?.payment_gateway_fee,
              ).toFixed(2)}
            </p>
          </>
        )}
        <p>Booking Total</p>
        <p>
          $
          {parseFloat(tableBookingDataProps?.billing?.booking_total).toFixed(2)}
        </p>
      </BookingDetailsItem>
      {tableBookingDataProps?.payment?.payment_at &&
        tableBookingDataProps?.payment?.payment_card?.brand &&
        tableBookingDataProps?.payment?.payment_card?.last4 && (
          <div>
            <p className="is-size-4 has-text-weight-semibold">
              Paid: $
              {parseFloat(
                tableBookingDataProps?.billing?.booking_total,
              ).toFixed(2)}{' '}
              on{' '}
              {moment(tableBookingDataProps?.payment?.payment_at).format(
                'ddd, MMM DD, YYYY hh:mm A',
              )}
            </p>
            <p>
              {tableBookingDataProps?.payment?.payment_card?.brand} ending in{' '}
              {tableBookingDataProps?.payment?.payment_card?.last4}
            </p>
          </div>
        )}
    </div>
    <div>
      <div>
        <p>
          <Label>Refunds</Label>
        </p>
        <RefundStats stats={refundSummary} />
      </div>
    </div>
  </GridContainer>
);

export default PaymentsTab;
